import React from 'react'
import { useLocation } from 'react-router-dom'
import HeaderLogo from '../../assets/images/logo_02.png'
import { getExitPath } from '../../utils/Utils'
import '../../assets/css/headerFooter.css'
const Header = () => {
    const location = useLocation()
    const cdp = (path) => {
        if (path.includes('recruit')) {
            return 'cdp-header'
        } else {
            return 'header'
        }
    }

    return (
        <div>
            <div className={cdp(location.pathname)}>
                <div id="headerLogo01"><a href='http://www.metlife.co.jp/'><img src={HeaderLogo} alt='MetLife　生命保険のメットライフ生命' /></a></div>
                <div><a href={getExitPath(location.pathname)} className='clearSession'><img src='/forms/image/header/btn_close.png' alt='×' width='35' height='35'/></a></div>
            </div>
        </div>
    )
}

export default Header
